import React from "react";
import styles from "./SimpleEqueue.style";
import { Text, Div, Card } from "@vkontakte/vkui";
import Icon16ClockOurline from "@vkontakte/icons/dist/16/clock_ourline";
import { format, parseISO } from "date-fns";
import { ru } from "date-fns/locale";

const SimpleEqueue = ({ equeue, done, onClick }) => {
  const getFullDateTime = (date) => {
    return format(parseISO(date), "dd MMMM, HH:mm", { locale: ru });
  };

  const getCardStyle = () => {
    if (done) {
      return {
        ...styles.card,
        ...styles.doneCard,
        zIndex: 1,
      };
    } else {
      return {
        ...styles.card,
        zIndex: 1,
      };
    }
  };

  /*  const getDoctorName = (comment) => {
        return comment.substring(comment.indexOf(',') + 1, comment.lastIndexOf("<")).trim();
    }*/

  /* const getDoctorSpeciality = (comment) => {
        if (comment.substring(comment.indexOf(':') + 1, comment.indexOf(',')).trim().length) {
            return comment.substring(comment.indexOf(':') + 1, comment.indexOf(',')).trim();
        } else {
            return comment;
        }
    }*/
  return (
    <Card mode="shadow" style={getCardStyle()} onClick={() => onClick()}>
      <Div
        style={{
          ...styles.cardHeader,
          ...styles.gray,
        }}
      >
        <Div style={styles.cardHeaderItem}>
          <Icon16ClockOurline style={styles.icon} />
          <Text style={styles.headerText}>
            {getFullDateTime(equeue.data.snippets[0].localDate)}
          </Text>
        </Div>
      </Div>
      <Text style={styles.doctorSpeciality}>
        {equeue.data.snippets[0].orgName}
      </Text>
      <Text style={styles.doctorName}>{equeue.data.snippets[0].address}</Text>
      {equeue.status === "reject" ? (
        <Div style={styles.cardFooterItem}>
          <Text
            style={{
              ...styles.headerText,
              ...styles.orange,
              paddingBottom: "16px",
            }}
          >
            Запись отменена заявителем
          </Text>
        </Div>
      ) : (
        <></>
      )}
    </Card>
  );
};

export default SimpleEqueue;
